import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { NotFoundPage } from './pages/404'
import { Home } from './pages/Home'
import { List } from './pages/consultations/List'
import { Show } from './pages/consultations/Show'

type Props = {}

const Routes: React.FC<Props> = () => {
  return (
    <Switch>
      <Route
        exact
        path="/features/qa/mild_cognitive_impairment/consultations/list"
      >
        <List />
      </Route>
      <Route
        exact
        path="/features/qa/mild_cognitive_impairment/consultations/:id"
      >
        <Show />
      </Route>
      <Route exact path="/features/qa/mild_cognitive_impairment/consultations">
        <Home />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  )
}

export default Routes
